module.exports = __webpack_public_path__ + "static/media/leather-shoes.7adde9b3.jpeg";